"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stripNonNumericChars = exports.getColor = exports.formatToCurrency = void 0;

var formatToCurrency = function formatToCurrency(text, locale) {
  if (typeof text !== 'string') {
    text = text ? text.toString() : '';
  }

  var parsedValue = parseInt(text.replace(/[^0-9]/g, ''));
  if (isNaN(parsedValue)) return '';
  return new Intl.NumberFormat(locale).format(parsedValue);
};

exports.formatToCurrency = formatToCurrency;

var getColor = function getColor(error, warning, disabled, _ref) {
  var errorColor = _ref.errorColor,
      warningColor = _ref.warningColor,
      defaultColor = _ref.defaultColor;
  if (disabled) return defaultColor;
  if (error) return errorColor;
  if (warning) return warningColor;
  return defaultColor;
};

exports.getColor = getColor;

var stripNonNumericChars = function stripNonNumericChars(text) {
  return text.replace(/[^0-9]/g, '');
};

exports.stripNonNumericChars = stripNonNumericChars;